module.exports = __webpack_public_path__ + "img/icon_youshi04.9a9054ff.png";